// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Start_wrapper__6tP8D {
  width: 360px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border-radius: 1px;
  padding: 10px 10px;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/Page/Start/Start.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX","sourcesContent":[".wrapper {\r\n  width: 360px;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\r\n  border-radius: 1px;\r\n  padding: 10px 10px;\r\n  margin: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Start_wrapper__6tP8D`
};
export default ___CSS_LOADER_EXPORT___;
